@if (opened) {
  <div>
    <div class="view-sidebar-container" fxLayout="column">
      <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center">
        <h3 fxLayout="row" fxLayoutAlign="start center">Manage Columns</h3>
        <div class="button-container">
          <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="isSaving || !canManageColumns"
            (click)="onSave()"
          >
            <mat-icon>check</mat-icon> Apply
          </button>
          <button
            type="button"
            mat-stroked-button
            (click)="onClose()"
            [disabled]="isSaving"
          >
            <mat-icon>close</mat-icon> Cancel
          </button>
        </div>
      </div>
      @if (!canManageColumns) {
        <app-plan-upgrade-box
          title="Upgrade to customize the displayed columns"
          body="You’ll be able to select which columns are on display from a wide range of data. Even better, you’ll be able to save the columns with your views, so you can set it and forget it."
        >
        </app-plan-upgrade-box>
      }
      <lineup-manage-columns
        [columns]="columns"
        [viewContext]="viewContext"
      ></lineup-manage-columns>
    </div>
  </div>
}
